export default __webpack_public_path__ + "static/media/General Information Sheet (GIS to 2021).61334e16.pdf";